import { InputHTMLAttributes } from 'react';

import { fontSizes, useTheme } from '../../theme';
import type { DefaultComponentProps, OmitStrict } from '../../types';
import Typography from '../Typography';

import {
  Circle,
  CircleContainer,
  InputElement,
  Root,
} from './SimpleToggle.styled';

export type SimpleToggleProps = OmitStrict<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'type'
> &
  DefaultComponentProps & {
    label?: string;
    checked?: boolean;
    isLabelHidden?: boolean;
  };
const SimpleToggle: React.FC<SimpleToggleProps> = ({
  'data-testid': dataTestId,
  label,
  checked = false,
  disabled = false,
  className,
  isLabelHidden,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Root $isDisabled={disabled} className={className} data-testid={dataTestId}>
      {!isLabelHidden && !!label && (
        <Typography
          color={theme.core.color.neutral[500]}
          fontSize={fontSizes.m}>
          {label}
        </Typography>
      )}

      <CircleContainer $isChecked={checked}>
        <InputElement
          aria-checked={checked}
          aria-label={label}
          {...rest}
          checked={checked}
          disabled={disabled}
          type="checkbox"
        />
        <Circle $isChecked={checked} />
      </CircleContainer>
    </Root>
  );
};

export default SimpleToggle;
